import { render, staticRenderFns } from "./BlackWhiteDialog.vue?vue&type=template&id=5673c9c4&"
import script from "./BlackWhiteDialog.vue?vue&type=script&lang=js&"
export * from "./BlackWhiteDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports